export const HandleCopyToClipboard = async (textToCopy, onSuccess = null, onError = null) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
    if (onSuccess) {
      onSuccess("Copied to clipboard!");
    } else {
      console.log("Copied to clipboard!");
    }
  } catch (err) {
    console.error("Failed to copy: ", err);
    if (onError) {
      onError("Failed to copy to clipboard");
    }
  }
};

  export const copyQRCodeToClipboard = async (svgElement, onSuccess = null, onError = null) => {
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvasSize = 512; // Match target resolution

    const canvas = document.createElement("canvas");
    canvas.width = canvasSize;
    canvas.height = canvasSize;

    const ctx = canvas.getContext("2d");
    const img = new Image();

    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    img.onload = async () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvasSize, canvasSize); // Force scale to 512x512
      URL.revokeObjectURL(url);

      canvas.toBlob(async (blob) => {
        try {
          await navigator.clipboard.write([
            new ClipboardItem({ "image/png": blob }),
          ]);
          if (onSuccess) {
            onSuccess("High-resolution QR code copied to clipboard!");
          } else {
            console.log("High-resolution QR code copied to clipboard!");
          }
        } catch (err) {
          console.error("Clipboard copy failed:", err);
          if (onError) {
            onError("Failed to copy image.");
          }
        }
      }, "image/png");
    };

    img.src = url;
  };